import script from "./PageContact.vue?vue&type=script&setup=true&lang=js"
export * from "./PageContact.vue?vue&type=script&setup=true&lang=js"

import "./PageContact.vue?vue&type=style&index=0&id=05cb68df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05cb68df"]])

export default __exports__